export default {
  title: 'Bestelling aanpassen',
  product_info: {
    earn_points: '{{points}} punten verdienen',
  },
};
